<script>

    import Time from "svelte-time";

    export let comment;

    export let config;
    export let reloadComments;

</script>

{#if comment.author === undefined}
    <h6 class="mb-0">Gelöschter Kommentar</h6>
    <p class="mb-2 mt-1"><i>Dieser Kommentar wurde gelöscht.</i></p>
{:else}
    <h6 class="mb-0">
        {@html comment.author}
        {#if comment.official == 1}
            <span class="badge bg-success text-white border-0 px-1 ms-1">Admin</span>
        {/if}
    </h6>
    <small class="text-muted"><Time timestamp="{comment.timestamp}" format="DD.MM.YYYY HH:mm" /></small>
    <p class="mb-2 mt-1">{@html comment.content}</p>
{/if}
